<!--
 * @Description: 
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <table-render ref="tableRender" :config="config" />
</template>

<script>
import tableRender from '@/components/tableRender';
import { getStorage } from '@/tools/storage';
import { main } from './config';

export default {
  data() {
    return {
      config: main
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    let user = getStorage('user') || {};
    if (user.isMainAccountNumber === 0) {
      this.config[0].childMenu[0].fields = main[0].childMenu[0].fields.filter(
        item => item.prop != 'operatorName'
      );
      this.config[0].childMenu[0].search = main[0].childMenu[0].search.filter(
        item => item.id != 'operatorName'
      );
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
